<template>
  <div id="classsingle">
    <!--购买单科、购买双科-->
    <div class="video"></div>
    <div id="popup-class">
      <div class="title">
        <div class="left">
          <!--<img src="../../../../assets/img/classsingle_header_class1.jpg" alt="">-->
          <img :src="smallBannerPic">
        </div>
        <div class="right">
          <h4>¥{{this.showPrice}}</h4>
          <p>{{this.className}}</p>
          <div class="gift">{{this.giftName}}</div>
        </div>
      </div>
      <!--课程种类-->
      <div class="type">
        <h5>课程种类</h5>
        <ul v-if="subjectData.status == 2">
          <li :class="{'active': isAllSubject}" @click="selectClass(1, 0, classPrice)">全科课程</li>
          <li :class="{'active': !isAllSubject}" @click="selectClass(2, singleData[0] ? singleData[0].id : 0, singleData[0].price)">单科课程</li>
        </ul>
        <ul v-else>
          <li class="active">无单科</li>
        </ul>
      </div>
      <!--选择科目-->
      <div class="subject" v-if="subjectData.status == 2 && !isAllSubject">
        <h5>选择科目</h5>
        <ul>
          <li v-for="(item, index) in singleData" :key="index" :class="{'active': singleId === item.id}" @click="selectClass(2, item.id, item.price)">{{item.name}}</li>
          <!-- 原设计稿
          <li>全程班</li>
          <li class="active">小学《教育教学知识与能力》单科</li>
          <li>小学《综合素质》单科</li>
          -->
        </ul>
      </div>
      <a @click="gotoSubmit" class="sub">提交订单</a>
    </div>
    <div class="bg" @click="hideChoose()"></div>
  </div>
</template>

<script>
export default {
  name: 'ClassSingle',
  data () {
    return {
      isShow: true,
      subjectData: {},
      infoId: 1, // 1 全科 2 单科
      singleId: 0, // 单科 ID  选择全科的时候 值为 0
      isAllSubject: true,
      singleData: {}, // 单科信息
      showPrice: this.classPrice
    }
  },
  props: [
    'classId',
    'shopType',
    'className',
    'giftName',
    'classPrice',
    'smallBannerPic'
  ],
  methods: {
    // 获得课程科目信息
    getSubject () {
      let data = {
        class_id: this.classId
      }
      this.$axios({
        method: 'GET',
        url: '/api/app/v1/get_live_first_type',
        params: data,
        headers: {
          'sign': this.$encryption(data, this.$store.state.token, this.$store.state.uid)
        }
      })
        .then(res => {
          console.log(res)
          if (res.data.errcode === 200) {
            this.subjectData = res.data.data
          } else if (res.data.errcode === 400) {
            this.$router.push({name: 'PwdLogin'})
          } else alert(res.data.message)
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 获得课程科目信息
    getSingle () {
      let data = {
        class_id: this.classId,
        info_id: 2
      }
      this.$axios({
        method: 'GET',
        url: '/api/app/v1/get_live_first_subject',
        params: data,
        headers: {
          'sign': this.$encryption(data, this.$store.state.token, this.$store.state.uid)
        }
      })
        .then(res => {
          console.log('单科信息：')
          console.log(res)
          if (res.data.errcode === 200) {
            this.singleData = res.data.data
          } else if (res.data.errcode === 400) {
            this.$router.push({name: 'PwdLogin'})
          } else console.log(res.data.message)
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 接口提交免费课程
    getFreeClass () {
      let data = {
        class_id: this.classId
      }
      this.$axios({
        method: 'POST',
        url: '/api/app/v1/post_order_free_payment',
        params: data,
        headers: {
          'sign': this.$encryption(data, this.$store.state.token, this.$store.state.uid)
        }
      })
        .then(res => {
          console.log(res)
          if (res.data.errcode === 200) {
            this.$router.push({name: 'MyClass'})
          } else if (res.data.errcode === 400) {
            this.$router.push({name: 'PwdLogin'})
          } else console.log(res.data.message)
        })
        .catch(err => {
          console.log(err)
        })
    },
    hideChoose () {
      this.$emit('listenShow')
    },
    // 课程选择：全科、单科
    selectClass (chooseInfoId, chooseSingleId, choosePrice) {
      if (chooseInfoId === 1) {
        this.isAllSubject = true
      } else {
        this.isAllSubject = false
      }
      this.infoId = chooseInfoId
      this.singleId = chooseSingleId
      this.showPrice = choosePrice
    },
    // 提交订单
    gotoSubmit () {
      // if (parseInt(this.showPrice) === 0) {
      if (parseFloat(this.showPrice) > 0) {
        this.$router.push({name: 'OrderConfirm', query: {shop_id: this.classId, shop_type: this.shopType, info_id: this.infoId, single_id: this.singleId}})
      } else {
        this.getFreeClass()
      }
    }
  },
  mounted () {
    this.getSubject()
    this.getSingle()
  }
}
</script>

<style scoped lang="stylus">
#classsingle
  .video
    display: none
    width: 7.5rem
    height: 4.4rem
    background: url(../../../../assets/img/classsingle_banner.png) no-repeat center
    -webkit-background-size: 100%
    background-size: 100%
    margin: 0 auto
  #popup-class
    position: fixed
    bottom: 0
    left: 0
    z-index: 10001
    width: 7.5rem
    height: 10.48rem
    background-color: #fff
    -webkit-border-radius: .2rem .2rem 0 0
    -moz-border-radius: .2rem .2rem 0 0
    border-radius: .2rem .2rem 0 0
    .title
      display: flex
      justify-content: space-between
      padding: 0 .4rem
      .left
        position: relative
        top: -.2rem
        width: 2rem
        height: 2rem
        border: .03rem solid #fff
        overflow: hidden
        -webkit-border-radius: .1rem
        -moz-border-radius: .1rem
        border-radius: .1rem
        -webkit-box-sizing: border-box
        -moz-box-sizing: border-box
        box-sizing: border-box
        img
          width: 100%
          height: 100%
      .right
        width: 4.3rem
        height: 2rem
        h4
          font-size: .36rem
          color: #FF7052
          margin: .12rem 0 0 0
        p
          font-size: .28rem
          color: #999
        .gift
          margin: .28rem 0 0 0
          font-size: .28rem
          color: #666
          &::before
            content: "赠"
            display: inline-block
            width: .4rem
            height: .4rem
            line-height: .4rem
            border: .02rem solid #FF6100
            margin-right: .2rem
            font-size: .28rem
            color: #FF7052
            text-align: center
            -webkit-border-radius: .08rem
            -moz-border-radius: .08rem
            border-radius: .08rem
    h5
      font-size: .36rem
      color: #050505
      font-weight: 600
    .type
      padding: 0 .4rem
      ul
        width: 100%
        height: .72rem
        margin: .32rem 0 0 0
        li
          display: inline-block
          width: 1.6rem
          height: .72rem
          line-height: .72rem
          border: .02rem solid #F4F4F4
          background-color: #F4F4F4
          margin: 0 .4rem 0 0
          color: #333
          font-size: .28rem
          text-align: center
          -webkit-border-radius: .36rem
          -moz-border-radius: .36rem
          border-radius: .36rem
          -webkit-box-sizing: border-box
          -moz-box-sizing: border-box
          box-sizing: border-box
          &.active
            border: .02rem solid #FF7052
            background: rgba(255,112,82,0.05)
            color: #FF7052
    .subject
      padding: .4rem
      ul
        width: 100%
        height: .72rem
        margin: .32rem 0 0 0
        li
          display: inline-block
          height: .72rem
          line-height: .72rem
          border: .02rem solid #F4F4F4
          background-color: #F4F4F4
          padding: 0 .4rem
          margin: .2rem .2rem 0 0
          color: #333
          font-size: .28rem
          text-align: left
          -webkit-border-radius: .36rem
          -moz-border-radius: .36rem
          border-radius: .36rem
          -webkit-box-sizing: border-box
          -moz-box-sizing: border-box
          box-sizing: border-box
          &.active
            border: .02rem solid #FF7052
            background: rgba(255,112,82,0.05)
            color: #FF7052
    a.sub
      position: absolute
      bottom: .4rem
      left: 50%
      display: block
      width: 6.7rem
      height: .8rem
      line-height: .8rem
      background-color: #FF7052
      font-size: .32rem
      color: #fff
      text-align: center
      -webkit-transform: translate(-50%, 0)
      -moz-transform: translate(-50%, 0)
      -ms-transform: translate(-50%, 0)
      -o-transform: translate(-50%, 0)
      transform: translate(-50%, 0)
      -webkit-border-radius: .4rem
      -moz-border-radius: .4rem
      border-radius: .4rem
  .bg
    position: fixed
    top: 0
    left: 0
    z-index:2000
    width: 100%
    height: 100%
    background-color: rgba(0, 0, 0, .4)
</style>



// WEBPACK FOOTER //
// src/components/share/popup/class/ClassSingle.vue